import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-horizontal-scroller',
  templateUrl: './horizontal-scroller.component.html',
  styleUrls: ['./horizontal-scroller.component.scss'],
})
export class HorizontalScrollerComponent implements AfterViewInit {
  @Input() snap = false;
  @Input() navigator = true;
  @Input() rowScroller = false;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @Input() checkWheel: boolean = false;
  slider: any;
  mouseDown = false;
  startX = 0;
  scrollLeft = 0;
  moved = false;
  scrollItemWidth = 0;
  scrollerTotalWidth = 0;
  numberOfItems = 0;
  scrollInterval: any;
  @ViewChild('dummy') dummy!: ElementRef;
  constructor() {}

  get arrayLength() {
    if (isNaN(this.numberOfItems)) return 0;
    else return this.numberOfItems;
  }

  get numberOfRows() {
    let num = Math.ceil(
      (this.numberOfItems * this.scrollItemWidth) / this.slider.offsetWidth
    );
    if (isNaN(num) || num == Infinity) num = 1;
    return Math.max(num, 1);
  }

  get rowWidth() {
    let width = (this.numberOfItems * this.scrollItemWidth) / this.numberOfRows;

    return width;
  }

  get activeRow() {
    let actualWidth = this.scrollItemWidth * this.numberOfItems;

    if (
      this.slider.scrollLeft >
      actualWidth - (this.slider.clientWidth + this.slider.scrollLeft)
    )
      return 1;
    return 0;
  }

  get activeItem() {
    return Math.floor(Math.abs(this.slider.scrollLeft) / this.scrollItemWidth);
  }

  get isScrollable() {
    let actualWidth = this.slider.offsetWidth;
    let neededWidth =
      this.numberOfItems * this.scrollItemWidth + 10 * this.numberOfItems;
    return actualWidth < neededWidth;
  }

  ngAfterViewInit() {
    this.slider = this.scrollContainer.nativeElement;
    this.initMouseListeners();
    this.initTouchListeners();
    new ResizeObserver(this.computeWidth.bind(this)).observe(this.slider);
    this.setupNavigation();
    this.addMutationObserver();
  }

  addMutationObserver() {
    const observer = new MutationObserver(() => {
      this.setupNavigation();
      this.computeWidth();
    });
    observer.observe(this.slider, {
      subtree: true,
      childList: true,
      attributes: true,
    });
  }

  setupNavigation() {
    setTimeout(() => {
      let childs = Array.from(this.slider.childNodes).filter(
        (el: any) => el.nodeType != 8
      );
      this.numberOfItems = childs.length - (this.dummy ? 1 : 0);
    }, 0);
  }

  computeWidth() {
    this.scrollerTotalWidth = this.slider.offsetWidth;
    let firstChild = this.slider.firstChild;
    this.scrollItemWidth = firstChild.offsetWidth;
    if (this.isScrollable && this.dummy != undefined) {
      this.dummy.nativeElement.style.minWidth =
        this.scrollerTotalWidth - this.scrollItemWidth + 50 + 'px';
      this.dummy.nativeElement.style.display = 'block';
    } else if (this.dummy != undefined)
      this.dummy.nativeElement.style.display = 'none';
  }

  initMouseListeners() {
    this.slider.addEventListener('mousedown', (event: any) => {
      if (!this.isScrollable) return;
      this.mouseDown = true;
      this.slider.classList.add('active');
      if (this.snap) this.slider.classList.remove('snap-inline');
      this.startX = event.pageX - this.slider.offsetLeft;
      this.scrollLeft = this.slider.scrollLeft;
    });
    this.slider.addEventListener('mouseleave', () => {
      if (!this.isScrollable) return;
      this.mouseDown = false;
      this.slider.classList.remove('active');
      if (this.snap) this.slider.classList.add('snap-inline');
    });
    this.slider.addEventListener('mouseup', () => {
      if (!this.isScrollable) return;
      this.mouseDown = false;
      this.slider.classList.remove('active');
      if (this.snap) this.slider.classList.add('snap-inline');
    });
    this.slider.addEventListener('mousemove', (e: any) => {
      if (!this.isScrollable) return;
      if (!this.mouseDown) return;
      this.moved = true;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - this.startX) * 1;
      this.slider.scrollLeft = this.scrollLeft - walk;
    });
  }

  initTouchListeners() {
    this.slider.addEventListener('touchstart', (event: any) => {
      if (!this.isScrollable) return;
      this.mouseDown = true;
      this.slider.classList.add('active');
      if (this.snap) this.slider.classList.remove('snap-inline');
      this.startX = event.changedTouches[0].pageX - this.slider.offsetLeft;
      this.scrollLeft = this.slider.scrollLeft;
    });
    this.slider.addEventListener('mouseleave', () => {
      if (!this.isScrollable) return;
      this.mouseDown = false;
      this.slider.classList.remove('active');
      if (this.snap) this.slider.classList.add('snap-inline');
    });
    this.slider.addEventListener('touchend', () => {
      if (!this.isScrollable) return;
      this.mouseDown = false;
      this.slider.classList.remove('active');
      if (this.snap) this.slider.classList.add('snap-inline');
    });
    this.slider.addEventListener('touchmove', (event: any) => {
      if (!this.isScrollable) return;
      if (!this.mouseDown) return;
      this.moved = true;
      event.preventDefault();
      const x = event.changedTouches[0].pageX - this.slider.offsetLeft;
      const walk = (x - this.startX) * 1;
      this.slider.scrollLeft = this.scrollLeft - walk;
    });
  }

  scrollTo(index: number) {
    if (!this.isScrollable) return;
    let displacment = this.scrollItemWidth * index - this.slider.scrollLeft;
    let dir = getComputedStyle(this.slider).direction;
    let polarity = index >= this.activeItem;
    if (dir == 'rtl') polarity = !polarity;
    displacment = Math.abs(displacment);
    this.scrollInterval = setInterval(() => {
      if (displacment > 0) {
        if (polarity) {
          this.slider.scrollLeft += 8;
        } else this.slider.scrollLeft -= 8;
        displacment -= 8;
      } else {
        clearInterval(this.scrollInterval);
      }
    }, 1);
  }

  scrollToRow(index: number) {
    if (!this.isScrollable) return;
    let displacment = this.rowWidth * index - this.slider.scrollLeft;
    let dir = getComputedStyle(this.slider).direction;
    let polarity = index >= this.activeRow;
    if (dir == 'rtl') polarity = !polarity;
    displacment = Math.abs(displacment);
    this.scrollInterval = setInterval(() => {
      if (displacment > 0) {
        if (polarity) {
          this.slider.scrollLeft += 8;
        } else this.slider.scrollLeft -= 8;
        displacment -= 8;
      } else {
        clearInterval(this.scrollInterval);
      }
    }, 1);
  }


  onScroll(event: WheelEvent): void {
  if (!this.checkWheel) return;
  const container = event.currentTarget as HTMLElement;
  if (event.deltaY !== 0) {
    event.preventDefault();
    container.scrollLeft += event.deltaY;
  }
}

}
